import { getLocations, getTitle as getCenterTitle } from '../center'
import { Center } from '@/types/models'
import { LocationAllowList } from '@/types/models/Location.model'
import { BreadCrumbs } from './computeBreadCrumbs'
import { getTitle as getLocationTitle } from '../location'
import { BANNED_LOCATION_TITLES } from '../location/constants'
import { isLocationCity } from '@/domain/location/useCases/isLocationCity'
import { rewriteCenterBreadcrumb } from './rewriteCenterBreadcrumb'
import { isObject } from '../../utils/checks'

interface ComputeCenterBreadCrumbs {
  (props: { center: Center; locationAllowList?: LocationAllowList }): {
    breadCrumbs: BreadCrumbs
    selectedTitle: string
  }
}

const dmaThreshold = 5

const computeCenterBreadCrumbs: ComputeCenterBreadCrumbs = ({
  center,
  locationAllowList
}) => {
  const locations = getLocations(center)
  const dmaLocation = center._locations?.find((loc) => !!loc?.dmaId)
  const targetLocationId = dmaLocation?.dmaId
  const targetLocation = locationAllowList?.find(
    (loc) => targetLocationId === loc.location_id
  )

  const validLocations = locations.filter(
    (item) => !BANNED_LOCATION_TITLES.has(getLocationTitle(item))
  )

  const seenTitles = new Set<string>()

  const transformedLocations = validLocations
    .map((item) => {
      const locationTitle = getLocationTitle(item)

      if (
        !isLocationCity(item) ||
        String(item.dmaId) !== String(dmaLocation?.dmaId)
      ) {
        return item
      }
      const locationData = locationAllowList?.find(
        (loc) => loc.title === locationTitle
      )
      const centerCount = locationData?.center_count ?? 0

      return centerCount < dmaThreshold && targetLocation
        ? targetLocation
        : item
    })
    .filter((item) => {
      const title = getLocationTitle(item)
      if (seenTitles.has(title)) return false
      seenTitles.add(title)
      return isObject(item)
    })
    .map((item) => rewriteCenterBreadcrumb({ center, item }))

  return {
    breadCrumbs: transformedLocations,
    selectedTitle: getCenterTitle(center)
  }
}

export default computeCenterBreadCrumbs
